import React, { useEffect, useState } from "react";
import { NavbarApp } from "../../../components";
import { useQuery } from "@tanstack/react-query";
import { getProfile } from "../../../data";
import AuthStore from "../../../stores/AuthStore";
import { observer } from "mobx-react";

export const AppLayout = (props) => {
  const [fistTimeForMount, setFistTimeForMount] = useState(true);
  const { data, isSuccess } = useQuery({
    queryKey: ["profile"],
    queryFn: getProfile,
  });
  useEffect(() => {
    //Todo: for permission control this code writed here, use effect is not good place for this code

    if (isSuccess) {
      if (data != null) {
        if (fistTimeForMount) {
          console.log("isSuccess b", isSuccess);
          AuthStore.setProfile(data.data.user);
        } else {
          console.log("isSuccess c", isSuccess);
        }

        setFistTimeForMount(false);
      }
    }
  }, [fistTimeForMount, isSuccess, data]);

  return (
    <div>
      <NavbarApp />
      <header className="max-w-7xl mx-auto p-4  lg:flex lg:items-center lg:justify-between ">
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            {props.title}
          </h2>
        </div>
        <div className="mt-5 flex lg:mt-0 lg:ml-4">
          {props.actions != null
            ? props.actions.map((item) => (
                <button
                  key={item.name}
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                  onClick={item.onClick}
                >
                  {item.name}
                </button>
              ))
            : ""}
        </div>
      </header>
      <main>
        <div className="max-w-7xl mx-auto  ">
          {props.loading && (
            <div>
              <h1>Loading...</h1>
            </div>
          )}
          {props.children}
        </div>
      </main>
    </div>
  );
};
